import { useScreen } from "../../../context/ScreenContext";
import MobileEditAccountModal from "./_components/mobile";
import WebEditAccountModal from "./_components/web";

type ModalProps = {
  user: any;
  onCancel: () => void;
}

const EditAccountModal = ({ onCancel, user }: ModalProps) => {
  const { isMobile } = useScreen();

  return isMobile
    ? <MobileEditAccountModal onCancel={onCancel} user={user} />
    : <WebEditAccountModal onCancel={onCancel} user={user} />
}

export default EditAccountModal;
